<template>
	<div class="spending-pot-button" @click.stop.prevent="$emit('click', $event)">
		<img :src="require('@/assets/icons/coins-swap-green.png')" alt="coins" class="icon" />
		<span class="text" v-if="amount > 0">You have <b>{{ formattedAmount }}</b> in your <b>Saved</b> pot</span>
		<span class="text" v-else>Find out how you can <b>save</b> when you <b>spend</b></span>
		<img :src="require('@/assets/arrow-right.png')" alt="arrow" class="arrow" />
	</div>
</template>

<script>
export default {
	props: {
		amount: {
			type: Number,
			default: 0
		}
	},
	computed: {
		formattedAmount() {
			return new Intl.NumberFormat('en-GB', {
				style: 'currency',
				currency: 'GBP'
			}).format(this.amount);
		}
	}
}
</script>

<style scoped>
.spending-pot-button {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	padding: 8px 12px;
	background: white;
	border-radius: 8px;
	box-shadow: 0px 4px 8px 0px rgba(51, 40, 71, 0.05);
	cursor: pointer;
}

.icon {
	width: 24px;
	height: 24px;
}

.text {
	flex: 1;
	font-size: 11px;
	color: #413655;
}

.arrow {
	width: 14px;
	height: 10px;
}
</style>
